const DASH = {
  SET_SUBSCRIPTIONS_QUERY: 'SET_SUBSCRIPTIONS_QUERY',
};

export default DASH;
